import { PAGE_DOCUMENT_SCHEMA_VERSION, } from '../../document/types.js';
import { checkoutPresets, checkoutSchema } from '../checkout/schema.js';
/**
 * The default checkout page (05/10/2026) — one `checkout` section carrying the look the storefront's
 * checkout always had: white page, grey summary column, dark ink, the theme's accent on the button.
 *
 * Three callers read it, and they must agree:
 *   - the BACKEND seeds a `(checkout, default)` page per store from its own mirror of this document, so
 *     the page exists in the builder the moment a store does;
 *   - the BUILDER opens this when a store has no such row yet (`buildDefaultDocument('checkout')`);
 *   - the STOREFRONT falls back to its settings when the published page is missing — a shop created
 *     before the template existed and not yet reached by the backfill. The checkout never stops
 *     rendering: the document only ever decides colours and sizes, never whether there is a form.
 *
 * @param locale the SHOP's language — the document carries its own, and a hardcoded `'fr'` is the
 *   mistake every other page builder in this folder has already made once.
 */
export function buildCheckoutPageDocument(locale = 'fr') {
    return {
        schemaVersion: PAGE_DOCUMENT_SCHEMA_VERSION,
        template: 'checkout',
        handle: 'default',
        locale,
        sections: [
            {
                id: 'checkout',
                type: 'checkout',
                version: checkoutSchema.version,
                settings: { ...checkoutPresets[0]?.settings },
                blocks: [],
            },
        ],
    };
}
//# sourceMappingURL=checkoutPage.js.map